import { SHARED_STEPS } from './shared.steps';
import { backButton, nextButton } from '../tourButtons';

export function getIndustrialSteps(t) {
  return [
    SHARED_STEPS.welcome(t),
    SHARED_STEPS.sidebar(t),

    {
      id: 'alerts',
      attachTo: { element: '[data-tour="nav-alerts"]', on: 'right' },
      title: t('tour.alerts.title'),
      text: t('tour.alerts.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'reports',
      attachTo: { element: '[data-tour="nav-reports"]', on: 'right' },
      title: t('tour.reports.title'),
      text: t('tour.reports.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'device-management',
      attachTo: { element: '[data-tour="nav-devices"]', on: 'right' },
      title: t('tour.devices.title'),
      text: t('tour.devices.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    SHARED_STEPS.settings(t),
    SHARED_STEPS.done(t),
  ];
}
